import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const YearsStrongIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 202.93 252.83" color="blue.800" {...rest} __css={styles}>
      <desc id="svgdescShield">
        shield with words 130 years strong with stars
      </desc>
      <path
        d="M101 2C65 2 32 7 2 16v115c0 71 99 119 99 119s99-48 99-119V16c-30-9-63-14-99-14Z"
        fill="#749abd"
      />
      <path
        d="M101 237a266 266 0 0 1-43-29c-13-11-24-23-31-34-9-15-14-29-14-43V24a328 328 0 0 1 38-7 370 370 0 0 1 100 0 328 328 0 0 1 38 7v107c0 14-5 28-14 43-7 11-18 23-31 34a267 267 0 0 1-43 29Z"
        className="accent"
      />
      <path
        d="M67 177h-6v-9l-3-6-4-8h6l4 10 4-10h5l-4 8-2 6v9Zm15-4h7v4H75v-23h13v4h-7v5h7v4h-7v6Zm17-2h-3l-1 6h-6l2-7 2-6 3-10h7l3 10 2 6 2 7h-6l-1-6h-1Zm0-4h3l-3-9-2 9Zm13-13h7l6 1 3 6c0 2-1 5-4 6l1 3 4 7h-6l-3-7-1-2h-2l1 9h-6a403 403 0 0 0-1-23Zm5 10a3 3 0 0 0 1 0c1 0 4 0 4-3 0-2-1-3-3-3h-2v6Zm27-9v4h-1a6 6 0 0 0-4-1l-3 2 3 3 2 1c2 1 4 3 4 6s-2 7-9 7a13 13 0 0 1-5-1v-4a7 7 0 0 0 5 2c2 0 3-2 3-3 0-2-1-2-3-3l-1-1c-2-2-4-3-4-7 0-5 4-6 7-6a13 13 0 0 1 6 1Zm-75 30v2l-1 1a4 4 0 0 0-2-1l-2 1 2 2 1 1 2 4c0 2-1 5-5 5a9 9 0 0 1-4 0v-4a5 5 0 0 0 3 2c2 0 2-2 2-2l-1-3h-1c-2-1-3-2-3-5s3-4 5-4a9 9 0 0 1 4 1Zm5 15v-13h-4v-3h12l-1 3h-3v13h-4Zm9-16h5l4 1a4 4 0 0 1 2 4 4 4 0 0 1-3 4l1 2a50 50 0 0 0 3 5h-5l-2-5v-1h-1v6h-4v-16Zm4 7c1 0 3 0 3-2l-2-2h-1v4Zm16 9c-4 0-7-2-7-8 0-4 1-8 7-8 4 0 7 2 7 8 0 8-5 8-7 8Zm0-13c-3 0-3 4-3 5 0 2 1 5 3 5s3-2 3-5-1-5-3-5Zm22-3v16h-4l-6-10 1 10h-4v-16h4l6 10v-10h3Zm15 1-1 3a5 5 0 0 0-3-1c-2 0-5 1-5 5 0 3 2 5 4 5a3 3 0 0 0 1 0v-5h4v7a15 15 0 0 1-5 1c-6 0-8-4-8-8 0-1 0-8 8-8a10 10 0 0 1 4 1ZM36 132l1-39V80h-8l1-13v-1l28-3h1l-1 37 1 31-1 1H37Zm33-3v-15l1-1c2 2 7 5 12 5 4 0 11-1 11-10 0-2 0-8-8-8a13 13 0 0 0-6 1l-1-1 6-11 5-9H69V64h47l-14 26c11 3 13 11 13 18 0 16-11 25-27 25a53 53 0 0 1-19-3Zm77-66c3 0 13 0 19 8s6 21 6 28c0 14-2 34-25 34-5 0-14-1-19-8-5-6-7-15-7-28 0-12 2-34 26-34Zm0 14c-5 0-5 7-5 21s0 21 5 21c4 0 4-8 4-20s0-22-4-22Z"
        className="background"
      />
      <path
        fill="#749abd"
        d="M29 53h145v3H29zm0 88h145v2H29zM70 26l2 6h6l-5 3 2 6-5-4-5 4 2-6-5-3h6l2-6zm31-7 3 9h10l-8 6 3 9-8-5-8 5 3-9-8-6h10l3-9zm31 7 2 6h6l-5 3 2 6-5-4-5 4 2-6-5-3h6l2-6z"
      />
    </Icon>
  );
};

export default YearsStrongIcon;
